import { Pipe, PipeTransform } from '@angular/core';
import { formatDuration, FormatDurationOptions } from '@vendasta/galaxy/utility/date-utils';

@Pipe({
  name: 'glxyDuration',
})
export class GalaxyDurationPipe implements PipeTransform {
  transform(seconds: number | null | undefined, options?: FormatDurationOptions): string {
    return formatDuration(Number(seconds ?? 0), options);
  }
}
